import React, { PropsWithChildren, ReactElement, useEffect } from 'react';
import { dbChangesClient } from 'shared/domain/dbChanges/dbChangesClient';
import { ProjectLoading, ProjectLoadingFailed } from 'views/projectLoading';
import { useIsProjectLoading, useProjectDataLoadingFailure } from 'store/project';

/** Once the project is loaded, the worker tells the views when stored data changes. */
function useDbChangesOnceLoaded(loading: boolean): void {
  useEffect(() => {
    if (loading) {
      return;
    }
    dbChangesClient.startListening();
  }, [loading]);
}

export type ProjectLoadingGateProps = {
  /** The view works without the project's data (the project list): a failed loading does not hide it. */
  showsContentOnFailure?: boolean;
};

function WithProjectLoading({
  children,
  showsContentOnFailure = false,
}: PropsWithChildren<ProjectLoadingGateProps>): ReactElement {
  const loading = useIsProjectLoading();
  const failure = useProjectDataLoadingFailure();
  useDbChangesOnceLoaded(loading);

  if (failure) {
    return showsContentOnFailure ? (
      <>{children}</>
    ) : (
      <ProjectLoadingFailed failure={failure} />
    );
  }
  return loading ? <ProjectLoading /> : <>{children}</>;
}

export { WithProjectLoading };
